import { useEffect, Dispatch, SetStateAction, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Union } from 'ts-toolbelt';

import { ModuleHashAction } from '~/modules/Module.types';

export interface UseHashActionEditProps {
  id: Union.Nullable<string>;
  active: boolean;
  editDisabled: boolean;
  editOpen: boolean | undefined;
  setEditOpen: Dispatch<SetStateAction<boolean | undefined>>;
  hashAction: Union.Nullable<string>;
}

export const useHashActionEdit = ({
  id,
  active,
  editDisabled,
  hashAction,
  setEditOpen,
  editOpen,
}: UseHashActionEditProps): void => {
  const navigate = useNavigate();
  const opened = useRef<boolean>(false);

  // triggering edit should only be done initially ->
  // using the ID from the query as dependency for the effect
  // as this will only change once after the data has loaded
  useEffect(() => {
    if (id && active && hashAction === ModuleHashAction.EDIT && !editDisabled) {
      opened.current = true;
      setEditOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, active]);

  // remove hash from url if edit state gets closed
  useEffect(() => {
    if (active && opened.current && editOpen === false) {
      opened.current = false;
      navigate({ hash: '' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editOpen]);
};
